import { render } from "./index.vue?vue&type=template&id=2b38bd30&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2b38bd30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b38bd30"],['__file',"src/views/components/Sidenav/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b38bd30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b38bd30', __exports__)) {
    api.reload('2b38bd30', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2b38bd30&scoped=true&ts=true", () => {
    api.rerender('2b38bd30', render)
  })

}


export default __exports__